import { combineReducers, configureStore } from '@reduxjs/toolkit';
import api from './services/api';
import identityApi from './services/identity';
import agreementsReducer from './agreements';
import authenticationReducer from './authentication';
import loginReducer from './login';
import networkGroupReducer from './networkGroup';
import signupReducer from './signup';
import userReducer from './user';
import { persistStore, persistReducer, FLUSH, REHYDRATE, REGISTER, PAUSE, PERSIST, PURGE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export const rootReducer = combineReducers({
  agreements: agreementsReducer,
  authentication: authenticationReducer,
  login: loginReducer,
  networkGroup: networkGroupReducer,
  signup: signupReducer,
  user: userReducer,
  [api.reducerPath]: api.reducer,
  [identityApi.reducerPath]: identityApi.reducer,
});

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['agreements', 'authentication', 'networkGroup', 'thrive', 'user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        // redux-persist actions do NOT conform to this middleware
        // https://github.com/rt2zz/redux-persist/issues/988
        serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, REGISTER, PAUSE, PERSIST, PURGE],
        },
      })
        .concat(api.middleware)
        .concat(identityApi.middleware),
  });
  const persistor = persistStore(store);
  return { store, persistor };
};
